import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=d4b61a7c&scoped=true"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"
import style0 from "./authentication.vue?vue&type=style&index=0&id=d4b61a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b61a7c",
  null
  
)

export default component.exports